import api from "@/api";

export default {
    /**
     * ApmType 문서함 목록 조회
     * @param comCode 회사코드
     * @param apmType 문서함타입
     * @returns
     */
    getDocumentBoxMenuListByApmType(comCode: string, apmType: number) {
        return api.get<appbase.cache.TMenuItem[]>({
            url: `/workflow/documentbox/api/menu/list/apmtype?comCode=${comCode}&apmType=${apmType}`,
        });
    },
    /**
     * 문서함 일반 설정 조회
     * @param menuId 메뉴아이디
     * @returns
     */
    getDocumentBoxPageByMenuId(menuId: number) {
        return api.get<workflow.TB_WORKFLOW_CONFIG_DOCUMENTBOX_PAGE>({
            url: "/workflow/documentbox/api/page?menuId=" + menuId,
        });
    },
};
